import update from 'immutability-helper'

import * as actions from '../actions/actions'

const initialState = {
  authenticatedUser: {
    username: '',
    fullName: '',
    token: null,
    role: '',
    idBank: '',
    corporateSenderId: '',
    authenticated: false,
    imageString:'',
    bankLogo:'',
    corporateLogo: '',
    primaryColor:'',
    secondaryColor:'',
    corporatePrimaryColor:'',
    corporateSecondaryColor:'',
    language: '',
    userReseted:false,
    userCorporates:[],
    report: true,
    distinte: true
  },
  error: ''
}

export default function authentication(state = initialState, action) {
  switch (action.type) {
    case actions.AUTHENTICATION_CLEAN_ERROR:
      return authenticationCleanError(state, action)
    case actions.AUTHENTICATION_LOGIN_SUCCESS:
      return authenticationLoginSuccess(state, action)
    case actions.AUTHENTICATION_LOGIN_FAILURE:
      return authenticationLoginFailure(state, action)
    case actions.AUTHENTICATION_LOGOUT_SUCCESS:
      return authenticationLogoutSuccess(state, action)
    case actions.AUTHENTICATION_LOGOUT_FAILURE:
      return authenticationLogoutFailure(state, action)
    case actions.AUTHENTICATION_OTP_SUCCESS:
      return authenticationOtpSuccess(state, action)
    case actions.AUTHENTICATION_OTP_FAILURE:
      return authenticationOtpFailure(state, action)
    case actions.AUTHENTICATED_USER_LOGO_UPDATE:
      return updateLogo(state,action)
    case actions.AUTHENTICATED_CORPORATE_USER_LOGO_UPDATE:
      return updateCorporateLogo(state,action)
    case actions.AUTHENTICATED_BANK_PRIMARY_COLOR_CHANGE:
      return updatePrimaryColor(state,action)
    case actions.AUTHENTICATED_BANK_SECONDARY_COLOR_CHANGE:
      return updateSecondaryColor(state,action)
    case actions.AUTHENTICATED_CORPORATE_PRIMARY_COLOR_CHANGE:
      return updateCorporatePrimaryColor(state,action)
    case actions.AUTHENTICATED_CORPORATE_SECONDARY_COLOR_CHANGE:
      return updateCorporateSecondaryColor(state,action)
    case actions.AUTHENTICATION_CLEAN_TOKEN:
      return cleanToken(state,action)
    case actions.AUTHENTICATION_CLEAR_RESET_PASSWORD:
      return updateUserResetFlag(state,action)
    case actions.SAVE_CORPORATE_CREATE_UPDATE_LIST:
      return updateUserCorporatesList(state,action)
    case actions.CHANGE_LANGUAGE_REQUEST:
      return updateUserLanguage(state,action)
    default:
      return state
  }
}

const authenticationLoginSuccess = (state, action) => {
  const expirationDate = new Date(new Date().getTime() + (60*60*1000));
  localStorage.setItem('token', action.value.token);
  localStorage.setItem('expirationDate', expirationDate);
  localStorage.setItem('userId', action.value.fullName);
  return update(
    state,
    {
      authenticatedUser: {
        username: {$set: action.value.username},
        fullName: {$set: action.value.fullName},
        token: {$set: action.value.token},
        idBank: {$set: action.value.idBank},
        corporateSenderId: {$set: action.value.corporateSenderId},
        role: {$set: action.value.role},
        imageString:{$set:action.value.imageString},
        bankLogo:{$set:action.value.bankLogo},
        corporateLogo:{$set:action.value.corporateLogo},
        primaryColor:{$set:action.value.primaryColor},
        secondaryColor: {$set:action.value.secondaryColor},
        corporatePrimaryColor:{$set:action.value.corporatePrimaryColor},
        corporateSecondaryColor: {$set:action.value.corporateSecondaryColor},
        language: {$set:action.value.language},
        userReseted: {$set:action.value.userReseted},
        userCorporates: {$set:action.value.userCorporates},
        report: {$set:action.value.report},
        distinte: {$set:action.value.distinte}
      },
      message: {$set: action.value.message},
    }
  )
}

const authenticationLoginFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const authenticationCleanError = (state, action) => {
  return {
    ...state,
    error: ""
  }
}



const authenticationLogoutSuccess = (state, action) => {
  return initialState
}

const cleanToken = (state,action) => {
  // return update(
  //     state,
  //     {
  //       authenticatedUser: {
  //         token: {$set: null}
  //       },
  //     }
  // )
  localStorage.removeItem('state');
  localStorage.removeItem('token');
  localStorage.removeItem('expirationDate');
  localStorage.removeItem('userId');

  return initialState
}

const authenticationLogoutFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const authenticationOtpSuccess = (state, action) => {
  return update(
    state,
    {
      authenticatedUser: {
        authenticated: {$set: action.value.authenticated}
      },
      error: {$set:""}
    }
  )
}

const authenticationOtpFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const updateLogo = (state,action)=>{
  return update(
      state,
      {
        authenticatedUser: {
          bankLogo:{$set:action.value}
        }
      }
  )
}

const updateCorporateLogo = (state,action)=>{
  return update(
    state,
    {
      authenticatedUser: {
        corporateLogo:{$set:action.value}
      }
    }
  )
}

const updatePrimaryColor = (state,action)=>{
  return update(
      state,
      {
        authenticatedUser: {
          primaryColor:{$set:action.value}
        }
      }
  )
}

const updateUserLanguage = (state,action)=>{
  debugger
  return update(
      state,
      {
        authenticatedUser: {
          language:{$set:action.value}
        }
      }
  )
}
const updateUserCorporatesList = (state,action)=>{
  return update(
      state,
      {
        authenticatedUser: {
          userCorporates:{$set:action.value}
        }
      }
  )
}
const updateSecondaryColor = (state,action)=>{
  return update(
      state,
      {
        authenticatedUser: {
          secondaryColor:{$set:action.value}
        }
      }
  )
}

const updateUserResetFlag = (state,action)=>{
  return update(
      state,
      {
        authenticatedUser: {
          userReseted:{$set:false}
        }
      }
  )
}

const updateCorporatePrimaryColor = (state,action)=>{
  return update(
    state,
    {
      authenticatedUser: {
        corporatePrimaryColor:{$set:action.value}
      }
    }
  )
}

const updateCorporateSecondaryColor = (state,action)=>{
  return update(
    state,
    {
      authenticatedUser: {
        corporateSecondaryColor:{$set:action.value}
      }
    }
  )
}